import { ItemWithMetaData, ItemsForReviewResponse } from "../api/Items";

import AmendmentPost from "./AmendmentPost";

const AmendmentEditPosts = ({
  isReadOnly,
  behaviors,
  postList,
  handleAction,
}: {
  isReadOnly: boolean;
  behaviors: string[];
  postList: ItemsForReviewResponse;
  handleAction: (action: "remove" | "edit", post?: ItemWithMetaData) => void;
}) => {
  if (!postList || postList?.items.length === 0) {
    return <span data-testid="no-posts">No Posts Found</span>;
  }

  return (
    <>
      <div>
        <div className="grid grid-cols-1 md:grid-cols-2 3xl:grid-cols-3 gap-5 auto-cols-[minmax(20rem,_1fr)]">
          {postList?.items.map((item) => (
            <AmendmentPost
              behaviors={behaviors}
              key={item.item.external_id}
              post={item}
              handleAction={(action, post) => handleAction(action, post)}
              isReadOnly={isReadOnly}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default AmendmentEditPosts;
